/* ==========================================================================
   Marketing Header
   Task F33: Shared header for all standalone (non-portal) pages
   ========================================================================== */

import { Link } from 'react-router-dom'

interface MarketingHeaderProps {
  /** Right-side navigation content (links, buttons, etc.) */
  children?: React.ReactNode
}

export function MarketingHeader({ children }: MarketingHeaderProps) {
  return (
    <header className="border-b border-charcoal/10 bg-white/50 backdrop-blur-sm sticky top-0 z-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="cursor-pointer">
            <span className="font-serif text-2xl text-deep-purple">
              TJM Labs
            </span>
          </Link>
          {children && (
            <nav className="flex items-center gap-4">{children}</nav>
          )}
        </div>
      </div>
    </header>
  )
}

export default MarketingHeader
